import actions from './actions'

export default function RepairLimitsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_REPAIRLIMIT:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_REPAIRLIMIT:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_REPAIRLIMIT:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_REPAIRLIMIT:
      return {
        ...state,
        editing: { repairLimitID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_REPAIRLIMIT_RECIEVED ||
      actions.UPDATE_REPAIRLIMIT_RECIEVED ||
      actions.DELETE_REPAIRLIMIT_RECIEVED:
      return {
        ...state,
        editing: { repairLimitID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
